export enum EnvironmentType {
  Dev = 0,
  SIT = 1,
  UAT = 2,
  Staging = 3,
  Production = 4,
}

export enum ApplipcationStoreType {
  Peak = 0,
  NewPeak = 1,
  Payroll = 2,
  Board = 3,
  Asset = 4,
  Tax = 5,
}

export enum LoadingStatusType {
  None = 0,
  Loading = 1,
  Success = 2,
  Fail = 3,
}

export enum SalaryDocumentType {
  Detail = 0,
  Summary = 1,
}

export enum CommentLogType {
  None = 0,
  Comment = 1,
  Log = 2,
}

export enum ExcludedAccountCodeFromCreate {
  Cash = 111101,
  CurrentAccounts = 111201,
  SavingAccounts = 111301,
  UncashedCheques = 111401,
  FixedDeposites = 112101,
  AccountsReceivable = 113101,
  ChequesReceivedInAdvance = 113102,
  AccountsPayable = 212101,
  ChequesPayable = 212102,
}

export enum ParamsReloadType {
  Reload = 1,
  IsMain = 2,
}

export enum ActionType {
  Create = 1,
  Edit = 2,
}

export enum TableSorting {
  DESC = 0,
  ASC = 1,
}
export enum ModalType {
  Basic = 1,
  Advance = 2,
}
export enum Locales {
  EN = "en",
  TH = "th",
}
export enum LanguageType {
  Th = 0,
  En = 1,
}
export enum RevenueDeductType {
  Revenue = 0,
  Deduction = 1,
}

export enum EmployeeNamePrefixType {
  None = 0,
  Khun = 1,
  Mr = 2,
  Mrs = 3,
  Ms = 4,
  Other = 5,
}

export enum TypeComponentNoti {
  success = 1,
  warn = 2,
  error = 3,
  upload = 4,
}

export enum IdentifyPersionType {
  CitizenId = 0,
  Passport = 1,
}
export enum PrompPayType {
  Phone = 0,
  CitizenId = 1,
}
export enum FinanceChanelType {
  Cash = 0,
  Bank = 1,
  PrompPay = 2,
}
export enum EmployeeOrderType {
  None = 0,
  Id = 1,
  Code = 2,
  Name = 3,
  Department = 4,
  Salary = 5,
}
export enum EmployeeContactType {
  Monthly = 0,
  Daily = 1,
  PerformanceBased = 2,
}
export enum BankType {
  None = 0,
  CurrentAccount = 1,
  SavingAccount = 2,
  FixedDeposit = 3,
}

export enum PndType {
  None = 0,
  PND1kor = 1,
  PND2Specialkor = 2,
  PND2 = 3,
  PND3 = 4,
  PND2kor = 5,
  PND3kor = 6,
  PND53 = 7,
  PND54 = 8,
}

export enum DepartmentType {
  Other = 0,
  GeneralManagement = 1,
  GeneralAdministration = 2,
  Sales = 3,
  Marketing = 4,
  Accounting = 5,
  Finance = 6,
  HumanResource = 7,
  Production = 8,
  Operation = 9,
  InformationTechnology = 10,
  Purchasing = 11,
  ResearchAndDevelopment = 12,
  Undefined = 13,
}

export enum TypeComponentNoti {
  Success = 1,
  Warn = 2,
  Error = 3,
  Upload = 4,
}

export enum DepartmentOrderType {
  None = 0,
  Id = 1,
  Code = 2,
  Name = 3,
  Archived = 4,
  Account = 5,
}

export enum EmployeeHistoryOrderType {
  Name = 1,
  Date = 2,
}

export enum RevenueDeductOrderType {
  None = 0,
  Type = 1,
  Code = 2,
  Name = 3,
  CalculateAnnualRevenue = 5,
  Archived = 6,
}

export enum SortingType {
  DESC = 0,
  ASC = 1,
}
export enum DefaultRevenueDeductType {
  Other = 0,
  Salary = 1,
  Commision = 2,
  Overtime = 3,
  Allowance = 4,
  Travel = 5,
  Bonus = 6,
  Position = 7,
  BenefitCostLiving = 8,
  BenefitMobilePhoneExpense = 9,
  BenefitTransporation = 10,
  BenefitHouseRental = 11,
  BenefitFood = 12,
  DiligenAllowance = 13,
  WithHoldingTax = 14,
  SocialSecurityFund = 15,
  ProvidentFund = 16,
  Fine = 17,
  Absence = 18,
  LeaveWithOutPay = 19,
  EmployeeWelfareFund = 20,
}
export enum DefaultRevenueType {
  Other = 0,
  Salary = 1,
  Commision = 2,
  Overtime = 3,
  Allowance = 4,
  Travel = 5,
  Bonus = 6,
  Position = 7,
  BenefitCostLiving = 8,
  BenefitMobilePhoneExpense = 9,
  BenefitTransporation = 10,
  BenefitHouseRental = 11,
  BenefitFood = 12,
  DiligenAllowance = 13,
}
export enum DefaultDeductType {
  Other = 0,
  WithHoldingTax = 14,
  SocialSecurityFund = 15,
  ProvidentFund = 16,
  Fine = 17,
  Absence = 18,
  LeaveWithOutPay = 19,
}
export enum TaxRevenueCalculationType {
  IncludeIncomeType401 = 0,
  Exclude = 1,
  IncludeIncomeType402 = 2,
}
export enum SocialSecurityRevenueCalculationType {
  Include = 0,
  Exclude = 1,
}
export enum PositionType {
  Operation = 0,
  Management = 1,
}
export enum PositionOrderType {
  None = 0,
  Id = 1,
  Code = 2,
  Name = 3,
  Archived = 4,
  Account = 5,
}
export enum SalaryStatusType {
  Draft = -2,
  AwaitApprove = -1,
  Approved = 0,
  Paid = 1,
}
export enum BankReferenceType {
  NONE = -1,
  OTHER = 0,
  BBL = 1,
  KBANK = 2,
  SCB = 3,
  SME = 4,
  KTB = 5,
  BAY = 6,
  KK = 7,
  CIMB = 8,
  TMB = 9,
  TISCO = 10,
  TCR = 11,
  TCAP = 12,
  BAAC = 13,
  EXIM = 14,
  UOB = 15,
  LHBANK = 16,
  SCBT = 17,
  GSB = 18,
  IBANK = 20,
  ICBC = 21,
  JPMORGAN = 22,
  CITIBANK = 23,
  SMBC = 24,
  DB = 25,
  BNP = 26,
  MIZUHO = 27,
  THAIPR = 28,
  BOC = 29,
  BOA = 30,
  RBS = 31,
  RHB = 32,
  IOB = 33,
  HSBC = 34,
  ANZ = 35,
  OCBC = 36,
  GHBANK = 37,
}
export enum SalaryOrderType {
  None = 0,
  Id = 1,
  Number = 2,
  IssuedDate = 3,
  EmployeeCount = 4,
  PaymentDate = 5,
  NetAmount = 6,
}
export enum SalaryTableStatusType {
  All = 0,
  Draft = 1,
  AwaitApprove = 2,
  Approved = 3,
  Paid = 4,
  Void = 5,
}

export enum IssuedPeakAccountStatusType {
  None = 0,
  IssuedWhenCreatedSalary = 1,
  IssuedWhenPaidPayment = 2,
}
export enum BankAccountType {
  Cash = 0,
  Bank = 1,
  ExpenseClaim = 2,
  WithheldTax = 3,
  WithholdingTax = 4,
  EWallet = 5,
}
export enum OnBoardingType {
  None = 0,
  ViewSetting = 1,
  ViewDepartment = 2,
  ViewEmployee = 3,
  ViewRevenueDeduct = 4,
  ViewPayrun = 5,
}

export enum MerchantType {
  None = 0,
  LimitedLiabilityPartnership = 1,
  CompanyLimited = 2,
  PublicCompanyLimited = 3,
  Shop = 4,
  OrdinaryPerson = 5,
  BodyOfPersons = 6,
  Others = 7,
  OrdinaryPartnership = 8,
  Foundation = 9, //มูลนิธิ
  Association = 10,
  JointVenture = 11,
}

export enum Role {
  None = 0,
  ViewOnly = 1, // ดูได้อย่างเดียว
  PartialRightsDraftOnly = 2, //สิทธิบางส่วน ร่างได้อย่างเดียว
  PartialRightsApproveAndReceivePayment = 3, //สิทธิบางส่วน อนุมัติและรับจ่าย
  PartialRightsRevenueOnly = 4, //สิทธิบางส่วน ฝั่งรายได้อย่างเดียว
  PartialRightsExpenseOnly = 5, //สิทธิบางส่วน ฝั่งรายจ่ายอย่างเดียว
  PartialRightsQuotationOnly = 6, //สิทธิบางส่วน ใบเสนอราคาอย่างเดียว
  StandardRightsViewReport = 7,
  StandardRightsNotViewReport = 8,
  Admin = 9,
}

export enum PeakPayrollExceptionCode {
  None = 0,
  CodeDuplicated = 1,
  CodeIsEmpty = 2,
  IsHaveEmployee = 3,
  IsHaveSalaryEmployee = 4,
  PasscodeInvalid = 5,
  EmailOrBankAccountNumberDuplicated = 6,
  StatementSlipPasscodeNull = 7,
  StatementSlipVoid = 8,
  WhtCertificateVoid = 9,
  WhtCertificatePasscodeNull = 10,
  BasicCreateSalary = 11,
  ProplusCreateSummarySalaryPeriod = 12,
  CanNotPaidBeforeIssueDate = 15,
  PositionCodeDuplicated = 16,
  CanNotCreateRecordAccrued = 17,
  CanNotCreateSSOExpense = 18,
  CanNotCreatePaidSaraly = 19,
  CanNotVoidSalaryDocument = 20,
  CannotCreateEmployeeLimit = 21,
}
export enum PeakExceptionResponseCode {
  None = 0,
  TransactionNumberDuplicated = 1,
  ContactNotFound = 2,
  ProductNotFound = 3,
  AccountNotFound = 4,
  LockByPeriod = 5,
  FreePackageOverCreateTransaction = 6,
  ProPlusImportTransaction = 7,
  FullPaymentAmount = 8,
  InputFieldEmptry = 9,
  TransactionIsVoided = 10,
  OverPaid = 11,
  ProductNameAndDescriptionIsDuplicated = 12,
  ProductTemplateCodeIsDuplicated = 13,
  AccountCodeIsDuplicated = 14,
  UnitCodeIsDuplicated = 15,
  BankAccountCodeIsDuplicated = 16,
  ContactCodeIsDuplicated = 17,
  TaxIdIsDuplicated = 18,
  ContactNameIsDuplicated = 19,
  IssuedTaxInvoiceDuplicated = 20,
  PaymentIsDeleted = 21,
  ApprovedTransactionDuplicated = 22,
  AcceptedQuotationDuplicated = 23,
  CanNotVoidInvoiceIsIssuedBillingNote = 24,
  CanNotVoidInvoiceIsIssuedCreditNote = 25,
  CanNotVoidReceiptIsIssuedCreditNote = 26,
  LockByUser = 27,
  LockBySystem = 28,
  LockByIssuedPP30 = 29,
  LockBySendEtaxInvoice = 30,
  CanNotVoidQuotationIsIssuedInvoice = 31,
  CanNotVoidQuotationIsIssuedReceipt = 32,
  CanNotCreateDuplicatedReceiptFromReferenceTransaction = 33,
  IssuedDuplicatedTaxInvoice = 34,
  ReceivedTaxInvoiceVatTotalOverflow = 35,
  ReceivedTaxInvoicePreVatTotalOverflow = 36,
  UserProfileIsAlready = 37,
  EmailPasswordIncorrect = 38,
  ContactIdBelongToMerchant = 39,
  MerchantIsVerified = 40,
  ReceivedTaxInvoiceNumberDuplicated = 41,
  DuplicateNameContactGroup = 42,
  ImportTransactionExceed = 43,
  IsHaveUserInSystem = 44,
  DuplicatedReferFriends = 45,
  DuplicateFileName = 46,
  CanNotVoidInvoiceIsIssuedDebitNote = 47,
  CanNotVoidReceiptIsIssuedDebitNote = 48,
  BankAccountNotFound = 49,
  OverInvitationUser = 50,
  UserAlreadyMerchant = 51,
  MerchantPackageIsNotAddUser = 52,
  CanNotEditSuperUser = 53,
  UserUpdateEqualEditUser = 54,
  CanNotRemoveSuperUser = 55,
  CanNotRemoveUser = 56,
  DuplicatedSettingNumberIndextString = 57,
  AuthorityRoleNotPermission = 58,
  NotHavePermissionUser = 59,
  NotHavePermissionFinance = 60,
  NotHavePermissionPayroll = 61,
  NotHavePermissionPeakBoard = 62,
  ApiPartnerNotFound = 63,
  MerchantIsNotAllowDuplicateContact = 64,
  CanNotDeleteThisFinance = 65,
  CanNotVoidAllocation = 66,
  CanNotVoidAllocationItem = 67,
  CanNotIsArchivedAllocationIncome = 68,
  CanNotIsArchivedAllocationExpense = 69,
  LockByIssuedPND3 = 70,
  LockByIssuedPND53 = 71,
  CanNotEditDocumentIsIssuedFromPayroll = 72,
  CreditLimitCannontCreate = 73,
  CreditLimitWarning = 74,
  CanNotVoidPaymentIsIssuedReceipt = 75,
  InvalidDocumentPassCode = 76,
  CanNotEditInvoiceIsIssuedDebitNote = 77,
  CanNotEditInvoiceIsIssuedCreditNote = 78,
  CanNotEditJournal = 79,
  CanNotUpdateJournalStatus = 80,
  CanNotVoidProductTemplate = 81,
  ProductTemplateNameCanNotEmpty = 82,
  CanNotAddNewPriceToProductService = 83,
  ProductServicePriceNameDuplicated = 84,
  InvalidINetAuthenticationData = 85,
  AssetPurchaseDateLessThanStopAssetDepreciationDate = 86,
  PackageErrorCode = 87,
  UpgradeToPackageErrorCode = 88,
  AssetTemplateCodeDuplicated = 89,
  CanNotEditTransactionAsset = 90,
  CanNotVoidAssetTemplateBecauseAssetTemplateIssuedAsset = 91,
  CanNotVoidAssetBecauseAssetIssuedByPurchaseAsset = 92,
  CanNotVoidAssetBecauseAssetIssuedBySaleAsset = 93,
  OverLimitAsset = 94,
  BillingTransactionCurrencyNotCorrect = 95,
  DuplicatedReceiveBillingNoteNumber = 96,
  CanNotSaleAssetBecauseDoesNotSelectAssetId = 97,
  CanNotSaleAssetBecauseSaleAssetDateLessThanStopDepreciationDate = 98,
  IsNotHaveContactRevenueDepartment = 99,
  IsNotHaveContactSalary = 100,
  IsNotHaveContactSSO = 101,
  CantDoPaymentIsHaveErrorPndType = 102,
  CanNotVoidUnit = 103,
  ChequeisreceivedandChequeisclearing = 104,
  ChartOfAccountCannotDeleted = 105,
  UserIsInSystemAlready = 106,
  UserNotFound = 107,
  InvitationIncorrect = 108,
  InvitationIncorrectOrExpired = 109,
  AssetTemplateIsDeleted = 110,
  OverCreditNoteAmount = 111,
  OverPaymentCreditNoteAmount = 112,
  CanNotCreateCreditNote = 113,
  CreditNoteDateLessThanReferenceTransactionDate = 114,
  CanNotVoidTransactionIsHaveReferenceDocumentPayment = 115,
  OverPaidReferenceDocumentPayment = 116,
  IsReferenceTransactionIssuedCreditNote = 117,
  IssueCreditNoteAmountOverReferenceCreditNote = 118,
  CannotVoidPaymentHavePND = 119,
  CanNotEditTransactionIsIssuedReferencePaymentDocument = 120,
  CanNotEditTransactionIsIssuedPayment = 121,
  CanNotCreateCreditNoteBecauseTransactionRefIsIssuedDebitNote = 122,
  CanNotCreateCreditNoteBecauseTransactionRefIsNoDebt = 123,
  CanNotCreateDebitNoteBecauseTransactionRefIsIssuedCreditNote = 124,
  CanNotGotReceiptBecauseNotHavePayment = 125,
  CanNotVoidBillingNoteBecausePaid = 126,
  BillingAmountCannotBeGreaterThanOutstandingBalanceOfTheDocument = 127,
  CanNotBePaid = 128,
  AccountingFirmDeleted = 129,
  NotHaveAfpRefCode = 130,
  AccountingFirmRegisted = 131,
  NotHaveAccountingFirmMerchant = 132,
  AccountingFirmMerchantDeleted = 133,
  InvalidPage365AuthenticationData = 134,
  DuplicatedSaleAsset = 135,
  ValidateProductMustHaveAccountId = 136,
  JournalModelNotFound = 137,
  JournalAccountDescriptionIsEmptryOrNull = 138,
  ValidateAssetMustHaveAccountId = 139,
  ProPlusRecurringTransaction = 140,
  ProBillingNote = 141,
  BankAccountNumberIsAllowDuplicate = 142,
  BasicCreateJournal = 143,
  InvalidBentoWebAuthenticationData = 144,
  NotHavePurchaseAccountAndSellAccountForProductTemplate = 145,
  InvalidLineMyShopAuthenticationData = 146,
  CanNotCreateCreditNoteBecauseReferenceTransactionTypeAsset = 147,
  CanNotCreateDebitNoteBecauseReferenceTransactionTypeAsset = 148,
  CanNotVoidPayment = 151,
  CanNotRedeemCode = 152,
  RedeemOnbordingPromoCodeNotFound = 153,
  CanNotDeleteContact = 160,
  CanNotCreateOrUpdatePaymentBankStatement = 161,
  NotFoundPaymentBankStatement = 162,
  CanNotVoidOrDeletePaymentBankStatement = 163,
  UnableToMakeBankReconciled = 164,
  UnableCreateDefaultDataMerchantSample = 165,
  DemoMerchantExist = 166,
  ProductTemplateIsNotHaveVatType = 167,
  InvalidShopeeAuthenticationData = 168,
  CanNotSetDueDateBeforeTransactionDate = 169,
  UnableToUndoBankReconciled = 170,
  UnableToAprroveBankReconciled = 171,
  NotFoundBankReconciled = 172,
  CannotEditProductAccountAndDescriptionBecauseTransactionItemNotMap = 173,
  CanNotAssignContactGroup = 174,
  CannotEditPaymentBecausePaymentItemNotMap = 175,
  MerchantIsNotAllowDuplicateContactTaxId = 176,
  TaxInvoiceNumberDuplicated = 177,
  ProCanImportBankStatement = 178,
  ProCanReconcile = 179,
  CanNotEditContactTransactionIsReferenceInvoice = 180,
  CanNotEditContactTransactionIsReferenceReceipt = 181,
  CanNotEditContactTransactionIsIssuedBillingNote = 182,
  CanNotEditContactTransactionIsReferenceQuotation = 183,
  CanNotEditContactTransactionIsReferenceBillingNote = 184,
  ReconciledAlready = 185,
  CanNotVoidBecauseJournalAccountIsReconciled = 186,
  InvalidLazadaAuthenticationData = 187,
  MerchantDeleteAlready = 188,
  MerchantNameNotEqual = 189,
  UserIsNotAdmin = 190,
  InvalidLightworkAuthenticationData = 191,
  QRPaymentSettingModelNotFound = 192,
  SCBQRPaymentCodeModelNotFound = 193,
  CanNotVoidBankCauseByHaveBankInSCBQR = 194,
  FreePackageNotAllowedSelectChartOfAccount = 195,
  FreePackageProductIsHaveMaximum = 196,
  FreePackageCannotCreateNewFinanceAccount = 197,
  FreePackageCannotCreateNewAccount = 198,
  PackageNotFound = 199,
  CanNotCreateContactHaveMaximumContact = 200,
  CanNotCreateContactPersonHaveMaximum = 201,
  FreePackageNotAllowedAttachFile = 202,
  CanNotCreateDocumentsDatingBackUpToTwoMonths = 203,
  CanNotEditJounalBecauseFreePackage = 204,
  CantPaidPaymentSCBQRCauseByBankAccountNotFound = 205,
  CanNotIssuedTaxInvoiceNotVat = 206,
  CantPaidPaymentSCBQRCauseByAccountModelNotFound = 207,
  CantPaidPaymentSCBQRCauseByQRPaymentSettingModelNotFound = 208,
  CantPaidPaymentSCBQRCauseBySettingSCBPaymentCodeModelNotFound = 209,
  CantPaidPaymentSCBQRCauseByBankAccountNotSet = 210,
  TransactionNewStatusCannotLessThanCurrentStatus = 211,
  TransactionCurrentStatusCannotBeRejected = 212,
  CanNotCreateBecauseHaveRecordZeroAmount = 213,
  CanNotCreateBecauseNotSupportMultipleBankAccount = 214,
  CanNotEditRecordDeleted = 215,
  NotHavePermissionAsset = 216,
  QuotationCreatedTransaction = 217,
  QuantityOverQuotation = 218,
  PriceOverQuotation = 219,
  CanNotEditInvoiceBecauseDocumentHasBeenReferredToOtherDocument = 220,
  ContactPersonNamePrefixOtherMaxLength = 221,
  ContactNamePrefixOtherMaxLength = 222,
  SkuCodeIsDuplicate = 223,
  CanNotEditQuantityTransactionReferenceQuotation = 224,
  CanNotEditPriceTransactionReferenceQuotation = 225,
  CanNotAddNewTransactionItemReferenceQuotation = 226,
  CanNotSendEmail = 228,
  BankReconcileIsAlready = 229,
  CanNotPaidPaymentSCBQRCauseByNotYetPaid = 230,
  NotFoundSCBQRCodeDataModel = 231,
  JournalItemReferenceTypeInValid = 232,
  JournalItemAccountInValid = 233,
  AffiliateAccountNotFound = 234,
  CannotCreateReceivedTaxInvoiceCauseByDocumentEdited = 235,
  CanNotVoidDocumentIsDeleted = 236,
  CanNotVoidDocumentIsReferenceTransaction = 237,
  CanNotUpdateDocumentIsDeleted = 238,
  CanNotUpdateDocumentIsReferenceTransaction = 239,
  CanNotCreateCreditNoteBecauseReferenceBillingNote = 240,
  CanNotCreateDebitNoteBecauseReferenceBillingNote = 241,
  LimitProductImage = 242,
  UnableToAddPEAKSupport = 247,
  BillingNoteIsNotShowTransactionItem = 248,
  ItemDescriptionOverLength = 249,
  DepositAlreadyIssued = 250,
  CanNotCreateMerchantBecauseEmptyMerchantName = 251,
  PurchaseDateLessThanDepreciateDate = 252,
  UpdateStatusTransactionIsDeleted = 253,
  AssetNotFound = 254,
  CantDeletedMerchantBecauseHaveAppConnect = 255,
  OverLimitReferenceDeposit = 256,
  DuplicateReferenceDeposit = 257,
  EmailVerificationLinkActivate = 258,
  EmailVerificationLinkExpire = 259,
  EmailVerificationCannotResendLessOneMinute = 260,
  ResendEmailDataInvalid = 261,
  EmailVerificationCannotResendUserVerifiedEmailComplete = 262,
  DepositIsVoided = 263,
  OverflowDepositReferenceRemaining = 264,
  ContactNotMatch = 265,
  GoodsReceiptNotMatchInvoiceReceipt = 266,
  RemainingGoodsReceiptNotMatchInvoiceReceipt = 267,
  GoodsReceiptAlreadyIssueInvoiceReceipt = 268,
  NotHavePermissionTransaction = 269,
  WrongFinanceTypeOrTransactionItemType = 270,
  ErrorTransactionIsHavePayment = 271,
  CanNotActionBecauseTransactionHaveDeposit = 272,
  InvoiceReceiptWaitingMatchingGoodsReceipt = 273,
  ErrorTransactionIsHaveReceivedTaxInvoice = 274,
  TransactionIsIssuedTaxInvoice = 275,
  ResetEmailExpired = 276,
  ResetEmailAlready = 277,
  CantVoidDepositForETaxInvoice = 278,
  GoodsReceiptNotMatchInvoiceReceiptPricingType = 279,
  GoodsReceiptNotMatchInvoiceReceiptSummary = 280,
  LimitTransactionValueOverFlow = 281,
  PaymentFileNotSelectBankAccount = 282,
  PaymentFileNotSelectTransaction = 283,
  PaymentFileNotHaveContactBankAccount = 284,
  UpgradePackageIsAlreadyUpgraded = 285,
  AllocationError = 286,
  QuotationAlreadyIssueDeposit = 287,
  QuotationAlreadyIssueGoodsReceipt = 288,
  QuotationAlreadyIssueInvoiceReceipt = 289,
  PndTypeNotFound = 290,
  WhtDeductTypeNotFound = 291,
  PaymentTransactionIsReconciled = 292,
  BankStatementIsDeleted = 293,
  PaymentTransactionIsDeleted = 294,
  ReconciledAmountNotMatch = 295,
  PaymentAdjustIsReconciled = 296,
  JournalItemFromPeakPaymentWillRemove = 297,
  BankStatementIsReconciled = 298,
  CanNotTransferSuperAdmin = 299,
  InsertRolePermissionError = 300,
  RoleHaveUser = 301,
  RoleNotExist = 302,
  PaymentTransactionHaveCheque = 303,
  TaxInvoiceReceivedDateIsNull = 304,
  ErrorTransactionIsHaveVat = 305,
  EmailNotVerify = 306,
  RejectedQuotationDuplicated = 307,
  PaymentMethodOverLimit = 308,
  ReferenceQuotationIsVoided = 309,
  CannotEditTransactionItemTaxInvoiceProductOrAccountChange = 310,
  LimitStockValueOverFlow = 311,
  CannotEditGoodInvoiceReceiptBecausePackageNotRight = 312,
  DebitNoteContactDiff = 313,
  DebitNoteDateLessThanReferenceTransactionDate = 314,
  ToCurrencyNetTotalOverTransactionReferenceQuotation = 315,
  DiscountOverQuotation = 316,
  CanNotEditDiscountTransactionReferenceQuotation = 317,
  CanNotEasyEditTransactionItemProductReferenceQuotation = 318,
  CanNotEasyEditTransactionItemAccountReferenceQuotation = 319,
  AcceptedPurchaseRequisitionDuplicated = 320,
  CanNotChangToDraftPurchaseRequisition = 321,
  NotApprovedPurchaseRequisitionDuplicated = 322,
  CanNotCancelTaskPurchaseRequisition = 323,
  SuccessPurchaseRequisitionDuplicated = 324,
  CanNotCancelSuccessPurchaseRequisition = 325,
  PurchaseRequisitionIsDeleted = 326,
  PurchaseRequisitionIsNotApprovedStatus = 327,
  TransactionStatusChanged = 328,
  PINCodeNotSetup = 359,
  InvalidPINCode = 360,
  CannotModifyPINCode = 361,
  InvalidPINCodeToken = 362,
  VerifyPINCodeMaxAttemptReached = 363,
}
export enum Module {
  Department = 1,
  Employee = 2,
  Export = 3,
  Position = 4,
  RevenueDeduct = 5,
  Salary = 6,
  Setting = 7,
  SalaryPaid = 8,
  SalarySSOPaid = 9,
  SalaryExpense = 10,
  Statement = 11,
  Payroll = 12,
  SummarySalary = 14,
  Tax = 15,
}
export enum ActionEvent {
  Create = 1,
  ReadDetail = 2,
  Update = 3,
  Delete = 4,
  Approve = 5,
  Print = 6,
  Download = 7,
  Archived = 8,
  ReadTable = 9,
  SuggestCode = 10,
  Import = 11,
  UploadImage = 12,
  DeleteImage = 13,
  ExportPayRun = 14,
  ExportSSOSalary = 15,
  ExportImportTemplatePayRunSalary = 16,
  ExportBankFile = 17,
  SendSlipEmail = 18,
  EmployeeDetailSalaryHistory = 19,
  ExportEmployeeByDepartment = 20,
  Sent50bisEmail = 21,
  CreateSummarySalary = 22,
  GetSummarySalaryDetail = 23,
  VoidSummarySalary = 24,
  GetWhtCertificate = 25,
  GetWhtCertificateWithPasscode = 26,
  GetWhtCertificatePasscodeInvalid = 27,
  PrintPndItem = 28,
  Addcomment = 29,
  VoidComment = 30,
  GetComment = 31,
}

export enum SalaryDisplayLog {
  None = 0,
  CreatePayRun = 1,
  ApprovePayRun = 2,
  RecordAccountPayRun = 3,
  RecordSocialSecurity = 4,
  ViewThisPayRun = 5,
  SendEmailEmployeeList = 6,
  EditPayrun = 7,
  VoidPayrun = 8,
  ExportPayRunReport = 9,
  ExportBankFile = 10,
  ExportSSOFile = 11,
  AddComment = 12,
  VoidComment = 13,
  DraftPayRun = 14,
  VoidSalaryPaid = 15,
  VoidSalaryExpense = 16,
  ReInsertSalaryActive = 17,
}

export enum SalarySelectedDateOptionType {
  None = 0,
  ThisMonth = 1,
  BeforeMonth = 2,
  ThisYear = 3,
  BeforeYear = 4,
}

export enum ChangeFormType {
  None = 0,
  DayOnDay = 1,
  WeakOnWeak = 2,
  MonthOnMonth = 3,
  QuarterOnQuarter = 4,
  YearOnYear = 5,
}

export enum SalarySummaryType {
  None = 0,
  GrossSalary = 1,
  Department = 2,
  RevenueDeduct = 3,
  Position = 4,
  Account = 5,
}

export enum EmployeeResignReason {
  BenefitProblems = 0,
  PeopleProblems = 1,
  HealthProblems = 2,
  TravelProblems = 3,
  OrganizationStructureProblems = 4,
  ChangeOfWorkplace = 5,
  FurtherStudy = 6,
  SelfEmployedBusiness = 7,
  ContractTerminated = 8,
  Other = 9,
}

export enum ChartOfAccountPaymentNotDisplayPayment {
  Cash = 111101,
  BankCurrentAccount = 111201,
  BankSavingsAccount = 111301,
  CheckDueButNotDeposited = 111401,
  BankFixedDeposit = 112101,
  OtherTemporaryInvestments = 112201,
  TradeReceivables = 113101,
  CheckInAdvance = 113102,
  Materials = 114101,
  InstantProducts = 114102,
  WorkInProcess = 114103,
  BankOverdrafts = 211101,
  TradePayables = 212101,
  CheckPaid = 212102,
  NonRefundableInterestPayment = 212203,
  Land = 124101,
  ConstructionWork = 124102,
  Building = 124103,
  BuildingRenovation = 124104,
  MachineryAndEquipment = 124105,
  OfficeEquipment = 124106,
  OfficeFurnishings = 124107,
  Vehicle = 124108,
  AccumulatedDepreciationBuilding = 124203,
  AccumulatedDepreciationBuildingImprovements = 124204,
  CumulativeDepreciationMachinery = 124205,
  AccumulatedDepreciationOfficeEquipment = 124206,
  AccumulatedDepreciationOfficeSupplies = 124207,
  AccumulatedDepreciationVehicles = 124208,
  Software = 125101,
  LeaseOrUseOfProperty = 125102,
  OtherIntangibleAssets = 125103,
  AccumulatedAmortizationSoftware = 125201,
  AccumulatedAmortizationLeaseholdOrUseRights = 125202,
  AccumulatedAmortizationOtherIntangibleAssets = 125203,
  DepreciationBuilding = 530703,
  DepreciationBuildingImprovements = 530704,
  DepreciationOfficeEquipment = 530706,
  DepreciationOfficeFurniture = 530707,
  DepreciationVehicles = 530708,
  AmortizationSoftware = 530801,
  AmortizationLeaseholdOrUseOfAssets = 530802,
  AmortizationฯtherIntangibleAssets = 530803,
  DepreciationMachinery = 510102,
  InvestmentInAssociatedCompany = 121102,
  InvestmentsInSubsidiaries = 121103,
  InvestmentsInJointVentures = 121104,
  OtherLongTermInvestments = 121105,
  LongTermLoansToRelatedParties = 122101,
  LongTermLoansToOtherPersons = 122102,
  InvestmentProperty = 123101,
  NonCurrentAssetsHeldForSale = 123201,
}

export enum PaymentType {
  Salary = 1,
  SSO = 2,
  EWF = 3,
}

export enum PaymentInOutFlowType {
  None = 0,
  CashIn = 1,
  CashOut = 2,
}

export enum UserType {
  Email = 0,
  Google = 1,
  Microsoft = 2,
}

export enum Package {
  None = -1,
  Trial = 0,
  Free = 1,
  Basic = 2,
  Pro = 3,
  ProPlus = 4,
  AFPFree = 5,
  AFPLedger = 6,
  AFPAccountant = 7,
  Premium = 8,
}

export enum AutoCalculateWhtType {
  CreateEmployee = 1,
  CreateSalary = 2,
}

export enum SummarySalaryOrderType {
  None = 0,
  Code = 1,
  CreateDateTime = 2,
}

export enum ConditionType {
  None = 0,
  WithholdingTax = 1,
  LeaveForever = 2,
  LeaveOneTime = 3,
}

export enum NetIncomeTaxType {
  None = 0,
  NetIncomeTaxType401 = 1,
  NetIncomeTaxType402 = 2,
}

export enum TaxIncomeType {
  None = 0,
  SalariesIncome = 1,
  SalariesIncomeHaveWithholdingTaxRate = 2,
  SeverancePay = 3,
  SalariesWorkingIncome = 4,
  GoodwillAndRightIncome = 5,
  InterestOrDiscountIncome = 6,
  ProfitSharingIncome = 7,
  BonusToShareholder = 8,
  PortionOfDecapitalized = 9,
  IncreasedCapital = 10,
  BenefitFromConsolidated = 11,
  BenefitFromTrade = 12,
  AssetRentalIncome = 13,
  ProfessionalServiceIncome = 14,
  ContractWorkIncome = 15,
  HireOfWorkIncome = 16,
  AdvertisingIncome = 17,
  PrizeOrRewardIncome = 18,
  OtherServicesExcludeHotelRestaurantAndInsurance = 19,
  DiscountOrTradePromotion = 20,
  Insurance = 21,
  NonPublicTransport = 22,
  CelebrityHiring = 23,
}

export enum SummarySalaryTableStatusType {
  All = 0,
  Void = 1,
}

export enum VerificationStatus {
  None = 0,
  Proccessing = 1,
  Success = 2,
}

export enum AuthorityRole {
  None = 0,
  ViewOnly = 1,
  PartialRights = 2,
  StandardRights = 3,
  Admin = 4,
}

export enum UserRight {
  None = 0,
  ViewOnly = 1,
  RevenueExpenseDraftOnly = 2,
  RevenueExpenseApproveOnly = 3,
  RevenueAll = 4,
  ExpenseAll = 5,
  QuotationOnly = 6,
  Standard = 7,
  BasicAndAdmin = 8,
  CreateRevenueOnly = 9,
  CreateExpenseOnly = 10,
  PurchaseOrderOnly = 11,
  RevenueDraftOnly = 12,
  ExpenseDraftOnly = 13,
  RevenueApproveOnly = 14,
  ExpenseApproveOnly = 15,
  QuotationDraftOnly = 16,
  QuotationApproveOnly = 17,
  PurchaseOrderDraftOnly = 18,
  PurchaseOrderApproveOnly = 19,
  ExpenseExceptPOAll = 20,
  RevenueExceptQOAll = 21,
  RevenueExpenseExceptQOandPOApproveOnly = 22,
}
export enum ActivityLogSource {
  None = 0,
  PEAK_Engine = 1,
  PEAK_Experience = 2,
  PEAK_API = 3,
  TransactionImport = 4,
  ZORT = 5,
  KetShopWeb = 6,
  XCommerce = 7,
  BentoWeb = 8,
  Wisible = 9,
  Empeo = 10,
  Recurring = 11,
  BoxMe = 12,
  PeakAsset = 13,
  LineConnect = 14,
  UCommerce = 15,
  Page365 = 16,
  PeakPayroll = 17,
  PeakBoard = 18,
  PeakTax = 19,
}
export enum FinanceAndAccountRights {
  None = 0,
  All = 1,
  FinanceAccessOnly = 2,
  GLAndStatementOnly = 3,
  DailyJournalsAll = 4,
  DailyJournalsDraftOnly = 5,
  DailyJournalsApproveOnly = 6,
  DailyJournalsAllAndFinance = 7,
  DailyJournalsDraftOnlyAndFinance = 8,
  DailyJournalsApproveOnlyAndFinance = 9,
  DailyJournalsAllAndGL = 10,
  DailyJournalsDraftOnlyAndGL = 11,
  DailyJournalsApproveOnlyAndGL = 12,
  FinanceAccountAndDailyJournalsDraftOnly = 13,
  FinanceAccountAndDailyJournalsApproveOnly = 14,
  FinanceAndGL = 15,
}
export enum DailyJournalsRightType {
  None = 0,
  DraftOnly = 1,
  ApproveOnly = 2,
  All = 3,
}
export enum PeakSource {
  None = -1,
  PeakMini = 0,
  PeakExperience = 1,
  PeakApi = 2,
  PeakTax = 3,
  LineConnect = 4,
  PeakPayroll = 5,
  PeakAdmin = 6,
  PeakAsset = 7,
  FileVault = 8,
  PeakBoard = 9,
  PeakMobile = 10,
}
export enum VideoFeedback {
  None = 0,
  Yes = 1,
  No = 2,
  Complete = 3,
  Submit = 4,
}

export enum Position {
  None = -1,
  Other = 0,
  BusinessOwner = 1,
  Bookkeeper = 2,
  Salesperson = 3,
  Admin = 4,
  Accountant = 5,
  Employee = 6,
  AccountingFirm = 7,
  Student = 8,
}

export enum PayrollDocumentSettings {
  PND1kor = 0,
  PND1korItem = 1,
  WithholdingTax = 2,
}

export enum ContactFinanceType {
  All = 0,
  InFlow = 1,
  OutFlow = 2,
}

export enum AbilityAction {
  Access = "Access",
  Create = "Create",
  Update = "Update",
}

export enum AbilitySubject {
  PeakAccount = "PeakAccount",
  PeakPayroll = "PeakPayroll",
  PeakAsset = "PeakAsset",
  PeakBoard = "PeakBoard",
  PeakTax = "PeakTax",
  PeakLineConnect = "PeakLineConnect",
  PeakMobile = "PeakMobile",
  PeakDocument = "PeakDocument",
  OldPeakAccount = "OldPeakAccount",
  ViewPaySalary = "ViewPaySalary",
  CreatePaySalary = "CreatePaySalary",
  EditPaySalary = "EditPaySalary",
  DeletePaySalary = "DeletePaySalary",
  ApprovePaySalary = "ApprovePaySalary",
  ViewSummarySalary = "ViewSummarySalary",
  CreateSummarySalary = "CreateSummarySalary",
  EditSummarySalary = "EditSummarySalary",
  DeleteSummarySalary = "DeleteSummarySalary",
  ApproveSummarySalary = "ApproveSummarySalary",
  Payment = "Payment",
  RecordDailyJournal = "RecordDailyJournal",
  ViewEmployee = "ViewEmployee",
  CreateEmployee = "CreateEmployee",
  EditEmployee = "EditEmployee",
  DeleteEmployee = "DeleteEmployee",
  ExportEmployee = "ExportEmployee",
  ViewDepartment = "ViewDepartment",
  CreateDepartment = "CreateDepartment",
  EditDepartment = "EditDepartment",
  DeleteDepartment = "DeleteDepartment",
  ExportDepartment = "ExportDepartment",
  ViewRevenueDeduct = "ViewRevenueDeduct",
  CreateRevenueDeduct = "CreateRevenueDeduct",
  EditRevenueDeduct = "EditRevenueDeduct",
  DeleteRevenueDeduct = "DeleteRevenueDeduct",
  ExportRevenueDeduct = "ExportRevenueDeduct",
  Setting = "Setting",
}

export enum EventActionDropdownEmployee {
  ShowModalAddEmployee = -1,
}

export enum BroadcastUserChannelType {
  None = 0,
  AuthenticatedNotification = 1,
  DisconnectNotification = 2,
  UpdateAllNotificationList = 3,
  MasterDeleteNotificationById = 4,
  UpdateNotificationCount = 5,
  MasterGetAllNotificationListByMerchantId = 6,
  MasterGetNotificationCountByMerchantId = 7,
  DisconnectNotificationAllTab = 8,
  ReCreateTab = 9,
  MasterSetNotificationIsSeenAll = 10,
  UpdateUnSeenNotificationList = 11,
  UpdateIsSeenNotificationList = 12,
  MasterGetUnSeenNotificationListByMerchantId = 13,
  MasterGetIsSeenNotificationListByMerchantId = 14,
  MasterSetNotificationIsSeenById = 15,
  UpdateIsSeenNotificationFromActionIsSeen = 16,
  CacheUpdateUserProfile = 17,
  CacheUpdateSelectedMerchant = 18,
}

export enum AuthenticatedNotification {
  Success = 1,
  Failed = 2,
}

export enum BroadcastTabChannelType {
  None = 0,
  MasterTabClose = 1,
}

export enum CacheType {
  None = 0,
  UserProfile = 1,
  SettingTableQuotation = 2,
  SettingTableDepositReceipt = 3,
  SettingTableInvoice = 4,
  SettingTableReceipt = 5,
  SettingTableSalesTaxInvoice = 6,
  SettingTableCreditNote = 7,
  SettingTableDebitNote = 8,
  SettingTableBillingNote = 9,
  SettingTablePurchaseOrder = 10,
  SettingTableDepositPayment = 11,
  SettingTableGoodsReceipt = 12,
  SettingTableInvoiceReceipt = 13,
  SettingTablePurchaseInventoryRecord = 14,
  SettingTableExpenseRecord = 15,
  SettingTablePurchaseOrderAsset = 16,
  SettingTablePurchaseAsset = 17,
  SettingTablePurchaseTaxInvoice = 18,
  SettingTableReceiveCreditNote = 19,
  SettingTableReceiveDebitNote = 20,
  SettingTableCombinedPaymentNote = 21,
  SettingTableDailyJournal = 22,
  SettingViewQuotation = 23,
  SettingViewDepositReceipt = 24,
  SettingViewInvoice = 25,
  SettingViewInvoiceSellAsset = 26,
  SettingViewRecurringInvoice = 27,
  SettingViewReceipt = 28,
  SettingViewReceiptSellAsset = 29,
  SettingViewRecurringReceipt = 30,
  SettingViewSalesTaxInvoice = 31,
  SettingViewCreditNote = 32,
  SettingViewDebitNote = 33,
  SettingViewPurchaseOrder = 34,
  SettingViewGoodsReceipt = 35,
  SettingViewDepositPayment = 36,
  SettingViewInvoiceReceipt = 37,
  SettingViewPurchaseInventoryRecord = 38,
  SettingViewExpenseRecord = 39,
  SettingViewRecurringExpense = 40,
  SettingViewPurchaseAsset = 41,
  SettingViewPurchaseOrderAsset = 42,
  SettingViewReceiveCreditNote = 43,
  SettingViewReceiveDebitNote = 44,
  SelectedMerchant = 45,
  SettingPriceProduct = 46,
  Account = 47,
  UserInApp = 48,
  Package = 49,
}

export enum IDBTransactionMode {
  ReadOnly = "readonly",
  ReadWrite = "readwrite",
  VersionChange = "versionchange",
}

export enum AuthenticationApplication {
  None = 0,
  PeakEngine = 1,
  PeakExperience = 2,
  PeakAsset = 3,
  PeakPayroll = 4,
  PeakBoard = 5,
  PeakTax = 6,
  PeakLineConnect = 7,
  PeakMobile = 8,
  PeakApi = 9,
}

export enum EmployeeWelfareFundCalculationType {
  Include = 0,
  Exclude = 1,
}

export enum EmployeeWelfareFundParticipation {
  None = 0,
  MandatoryParticipation = 1,
  VoluntaryParticipation = 2,
  NonParticipant = 3,
}

export enum BranchCompanyType {
  None = 0,
  Quarter = 1,
  Branch = 2,
}

export enum AuthenticationResponseCode {
  OK = 200,
  RequireEmailOTP = 201,
  RequireAuthenticatorOTP = 202,
  EmailPasswordIncorrect = 301,
  PasswordExpired = 302,
  EmailOTPAlreadyRequested = 303,
  EmailOTPExpired = 304,
  DisabledTwoFactor = 305,
  PINCodeNotSetup = 359,
  InvalidPINCode = 360,
  CannotModifyPINCode = 361,
  InvalidPINCodeToken = 362,
  VerifyPINCodeMaxAttemptReached = 363,
}

export enum TwoFactorAuthenticationType {
  None = 0,
  Email = 1,
  Authenticator = 2,
}

export enum UserPINStatus {
  Locked = -1,
  None = 0,
  Active = 1,
  ForceSetup = 2,
}

export enum VerifyPINAction {
  None = 0,
  VerifySetupPINCode = 1,
  VerifyPINCode = 2,
}

export enum SettingPageType {
  None = 0,
  Organization = 1,
  LogoStamp = 2,
  Fund = 3,
  BankAccount = 4,
  AccountingRecord = 5,
}
